module.exports = __webpack_public_path__ + "fonts/MyriadPro-Regular.d75d7f70.otf";